// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/data-item-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'statusId', 'categoryId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    subTitle: {
      type: 'string',
      nullable: true,
    },
    comment: {
      type: 'string',
      nullable: true,
    },
    pictureDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    statusId: {
      type: 'integer',
    },
    statusCaption: {
      type: 'string',
      nullable: true,
    },
    categoryId: {
      type: 'integer',
    },
    categoryCaption: {
      type: 'string',
      nullable: true,
    },
    validFrom: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    validUntil: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    contentTypeId: {
      type: 'integer',
      nullable: true,
    },
    contentTypeCaption: {
      type: 'string',
      nullable: true,
    },
    searchTerms: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
